// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"3ad030430f4880069f38","655":"8f4b2850473ea58d68b9"}[chunkId] + ".js";
};